import { createContext } from 'react';
import type { RefreshPartnerTokenResponse } from '@/lib/providers/auth-provider';
import type { Role } from '@/shared/constants/roles';

export interface PartnerKeycloakCurrentUser {
	id: string;
	name: string;
	badge: string;
	email: string;
	email_verified: boolean;
	cpf_cnpj: string;
	roles: Array<Role>;
}

export interface VerifyCredentialsParams {
	code: string;
	state: string;
}
interface AuthContextData {
	isLoading: boolean;
	userId: PartnerKeycloakCurrentUser['id'] | undefined;
	userRoles: PartnerKeycloakCurrentUser['roles'];
	getLoginUrl(): Promise<void>;
	refresh(): Promise<void>;
	getLogoutUrl(): void;
	verifyCredentials({ code, state }: VerifyCredentialsParams): Promise<RefreshPartnerTokenResponse | undefined>;
}

export const AuthContext = createContext<AuthContextData | null>(null);
